export class AppConstants {
    public abbrvMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    public bandsInTownURL = 'https://rest.bandsintown.com/artists/Boombox%20Cartel/events?app_id=boomboxcartel';
  }
